export default "__VITE_ASSET__CQhOrU5I__"